import { useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import DateFilter from "../../components/DateFilter";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { parseDateFormat } from "../../Utils/utils";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useGetRainFallAPIQuery } from "../../redux/services/apiHome";
import { resetSubmitDate, setSubmitDate } from "../../redux/slice/sliceHome";
import { skipToken } from "@reduxjs/toolkit/query";
import PageLastUpdated from "../../components/shared/PageLastUpdated";

const RainFallDetailPage = () => {
  const dispatch = useDispatch();
  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const formattedDate = `${year}-${month}-${day}`;

  useEffect(() => {
    dispatch(setSubmitDate(formattedDate));
    return () => {
      dispatch(resetSubmitDate());
    };
  }, []);
  const { id } = useParams();

  const { submitDate } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();

  const { data: fetchedData = [] } = useGetRainFallAPIQuery(
    submitDate && id
      ? {
          date: submitDate,
          damId: id,
        }
      : skipToken
  );

  const rainFallData = fetchedData.node_data;
  const termData = fetchedData.term_data;

  const reservoirObj = termData?.find((item) => item.dm_id === id);

  const [dateInput, setDateInput] = useState(
    new Date().toISOString().split("T")[0]
  );

  function getLatestRainfallRecord(rainFallData) {
    if (!rainFallData || !Array.isArray(rainFallData)) return null;
    const withParsedDates = rainFallData.map((item) => ({
      ...item,
      parsedDate: parseDateFormat(item.changed_date),
    }));
    const sorted = withParsedDates.sort((a, b) => b.parsedDate - a.parsedDate);
    return sorted[0];
  }

  const latestUpdated = getLatestRainfallRecord(rainFallData);

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={getText("Reservoir Status", "जलाशय स्थिति")}
        titleLink="/reservoir-status"
        titleLink2={"/reservoir-status"}
        titleTwo={getText("Rain Fall Data", "वर्षा आंकड़े")}
        titleThree={reservoirObj?.dm_name}
        isActive={reservoirObj?.dm_name}
        levelTwo={true}
        levelThree={true}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-2 col-lg-6 mb-3">
                <DateFilter dateInput={dateInput} setDateInput={setDateInput} />
              </div>
              <div className="col-12 col-md-6 col-lg-6 mb-3 justify-content-end">
                {fetchedData?.node_data?.length !== 0 && (
                  <PageLastUpdated
                    lastUpdatedOn={latestUpdated?.changed_date}
                  />
                )}
              </div>

              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="table-responsive">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        <th>{getText("date", "दिनांक")}</th>
                        <th>{getText("Project Name", "परियोजना का नाम")}</th>
                        <th className="no-wrap-td">
                          {getText("Rain Fall (in mm)", "वर्षा (मिमी में)")}
                        </th>
                        <th>{getText("Remarks", "टिप्पणी")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fetchedData?.node_data?.length > 0 ? (
                        fetchedData?.node_data?.map((item, index) => (
                          <tr key={index}>
                            <td className="no-wrap-td">
                              {item.date_rain_fall}
                            </td>
                            <td className="no-wrap-td">{item.title}</td>
                            <td>{item.field_rain_fall_in_mm}</td>
                            <td>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.rain_fall_remarks,
                                }}
                              ></div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="11" className="text-center">
                            {getText(
                              "No records found",
                              "कोई रिकॉर्ड नहीं मिला                            "
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RainFallDetailPage;
